import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    Button,
    Table,
    message,
    DatePicker,
    InputNumber,
    Pagination,
    Input,
} from "antd";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class PalyerStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        exportLoading: false, // 导出是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            vendor_id: undefined,
            member_uid: undefined,
            kpoker_uid: undefined,
            date: [],
        },
        data: [], // 表格数据
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/kpoker_union/player_stat", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/kpoker_union/export_player_stat", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    vendor_id: undefined,
                    member_uid: undefined,
                    kpoker_uid: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["kpokerPlayerIdPlaceholder"]}
                        value={this.state.queryParams.kpoker_uid}
                        onChange={(value) =>
                            this.handleSetQueryParamsData("kpoker_uid", value)
                        }
                    />
                    <Input
                        allowClear
                        placeholder={this.props.language["proxyIdPlaceholder"]}
                        value={this.state.queryParams.vendor_id}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("vendor_id", e.target.value)
                        }
                    />
                    <Input
                        allowClear
                        placeholder={this.props.language["memberIdPlaceholder"]}
                        value={this.state.queryParams.member_uid}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("member_uid", e.target.value)
                        }
                    />
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.state.data, "kpoker_uid")}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["kpokerPlayerId"]}
                            dataIndex="kpoker_uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["proxyId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/proxy_detail/${item.vendor_id}`}>
                                    {item.vendor_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["memberId"]}
                            dataIndex="member_uid"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["palyerTotalProfit"]}
                            dataIndex="profit"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeeContribution"]}
                            dataIndex="fee_gain"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceContribution"]}
                            dataIndex="ins_gain"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceBuyamount"]}
                            dataIndex="ins_buy_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyContribution"]}
                            dataIndex="cowboy_gain"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyBetAmount"]}
                            dataIndex="cb_buy_in_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityBouns"]}
                            dataIndex="activity_bonus"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["propsConsumeIntergral"]}
                            dataIndex="prop_cost_point"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeesPercentage"]}
                            dataIndex="fee_share"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insurancePercentage"]}
                            dataIndex="ins_share"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboysProportion"]}
                            dataIndex="cowboy_share"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalProportion"]}
                            dataIndex="total_share"
                        />
                    </Table>
                    <Pagination
                        className="pagination"

                        showQuickJumper
                        showSizeChanger
                        size={isMobileDevice() ? 'small' : ''}
                        showTotal={(total) =>
                            `${this.props.language["total"]} ${total} ${this.props.language["item"]}`
                        }
                        pageSizeOptions={["10", "20", "30", "40"]}
                        current={this.state.queryParams.page}
                        pageSize={this.state.queryParams.limit}
                        total={this.state.queryParams.total}
                        onChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                        onShowSizeChange={(current, pageSize) =>
                            this.hanldeChangePage({ current, pageSize })
                        }
                    />
                </div>
            </div>
        );
    }
}
